import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~shared/api";

export const useResetFixture = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { mutateData } = useApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fixtureId: string) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/fixtures/${fixtureId}/reset?forceDelete=true`,
        method: "POST",
      });
    },
    onSuccess: (response: any) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        queryClient.invalidateQueries({
          queryKey: ["fixtureListPage", sport, organizationId, seasonId],
        });
      }
    },
  });
};
